module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('h3', [_vm._v("Sign In")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.signIn
    }
  }, [_vm._v("Connection")]), _vm._v(" "), _c('p', [_vm._v("Don't have an account? You can "), _c('router-link', {
    attrs: {
      "to": "/sign-up"
    }
  }, [_vm._v("create one here!")])], 1), _vm._v(" "), _c('p', [_vm._v("You can also participate "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.anonSignIn
    }
  }, [_vm._v("anonymously")]), _vm._v(".")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c79c4b3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 174
// module chunks = 1